/* Shared formatters / helpers for calculator pages. */
export const formatUSD = (n) =>
  typeof n === "number"
    ? n.toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 0,
      })
    : "—";

export const formatPct = (n, digits = 1) =>
  typeof n === "number" ? `${(n * 100).toFixed(digits)}%` : "—";

export const buildApplyQuery = (params) => {
  const out = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== null && v !== undefined && v !== "") out.set(k, String(v));
  });
  return out.toString();
};
